export interface ResolvedStory {
  full_slug: string
  uuid?: string
  name?: string
  content?: Record<string, any>
}

// Mirrors the availability check in src/app/[[...slug]]/page.tsx: a story with no
// location restriction renders on both sites, otherwise only where it is listed.
export function isAvailableForLocation(
  locationAvailable: string | undefined,
  location: string
): boolean {
  if (locationAvailable === undefined || locationAvailable === '') return true
  return locationAvailable.includes(location)
}

// Storyblok relations arrive as a uuid string (or the raw rels array) until
// resolve_relations replaces them with the story object.
export function isResolvedStory(rel: unknown): rel is ResolvedStory {
  return (
    typeof rel === 'object' &&
    rel !== null &&
    !Array.isArray(rel) &&
    typeof (rel as ResolvedStory).full_slug === 'string'
  )
}

// The Storyblok client inlines resolved relations into content, but bridge
// live-editing events and relation-overflow responses still deliver the raw
// uuid, in that case fall back to looking it up in the response's rels array.
export function resolveStoryRelation(rel: unknown, rels?: unknown[]): ResolvedStory | undefined {
  if (isResolvedStory(rel)) return rel as ResolvedStory
  if (typeof rel === 'string' && rel !== '' && Array.isArray(rels)) {
    return rels.find(
      (candidate) => isResolvedStory(candidate) && (candidate as ResolvedStory).uuid === rel
    ) as ResolvedStory | undefined
  }
  return undefined
}
